/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// nodejs library to set properties for components
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
// reactstrap components
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from 'reactstrap'
import './style.css'
import { useLocation } from 'react-router'
import { useEffect, useState } from 'react'

function CardsHeader({ name, parentName }) {
  const { theme } = useSelector((state) => state.themeConfig)
  const [forceRepaintKey, setForceRepaintKey] = useState(0)
  const [previewHeaderColor, setPreviewHeaderColor] = useState(null)
  const location = useLocation()
  const inViewCourse = useSelector((state) => state.courses.inViewCourse)
  const courseName = useSelector((state) => state.courses.name)

  useEffect(() => {
    // Function to force a repaint
    const forceRepaint = () => {
      setForceRepaintKey((prevKey) => prevKey + 1)
    }
    // Call the forceRepaint function when the component mounts or when location changes
    setTimeout(forceRepaint, 0)
  }, [location])

  // Listen for preview messages from admin iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'http://localhost:5173') return

      if (event.data.type === 'UPDATE_LEARNING_PREVIEW') {
        const { navbarColor } = event.data
        setPreviewHeaderColor(navbarColor || null)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  const path = location.pathname
  const isJobPage = path.includes('/job')
  const isProfilePage = path.includes('/profile')
  const hasLongCourseName = inViewCourse && courseName.length >= 35

  const { headerPadding, jobsClass } = (() => {
    if (isJobPage) return { headerPadding: '1.5em', jobsClass: 'jobs-header' }
    if (hasLongCourseName)
      return { headerPadding: '1em', jobsClass: 'jobs-header' }
    if (inViewCourse) return { headerPadding: '0', jobsClass: 'jobs-header' }
    if (isProfilePage) return { headerPadding: '0' }
    return { headerPadding: '3em', jobsClass: '' }
  })()

  return (
    <>
      <div
        key={forceRepaintKey}
        className={`header ${
          !location.pathname.includes('/job') ? 'pb-6' : ''
        } page-card-header ${
          theme.color && theme.color !== '' ? '' : 'bg-gradient-custom'
        } ${inViewCourse || (isProfilePage && 'dynamic-header-spacing')} ${jobsClass}`}
        style={{
          backgroundColor:
            previewHeaderColor ||
            (theme.color && theme.color !== '' ? theme.color : undefined),
          padding: headerPadding,
          marginTop: '-5px',
        }}
      >
        {/* <Container fluid>
					<div className='header-body'>
						<Row className='align-items-center py-4'>
							<Col lg='6' xs='7'>
								<h6 className='h2 text-white d-inline-block mb-0'>{name}</h6>{' '}
								<Breadcrumb
									className='d-none d-md-inline-block ml-md-4'
									listClassName='breadcrumb-links breadcrumb-dark'
								>
									<BreadcrumbItem>
										<a href='#pablo' onClick={(e) => e.preventDefault()}>
											<i className='fas fa-home' />
										</a>
									</BreadcrumbItem>
									<BreadcrumbItem>
										<a href='#pablo' onClick={(e) => e.preventDefault()}>
											{parentName}
										</a>
									</BreadcrumbItem>
									<BreadcrumbItem aria-current='page' className='active'>
										{name}
									</BreadcrumbItem>
								</Breadcrumb>
							</Col>
						</Row>
					</div>
				</Container> */}
      </div>
    </>
  )
}

CardsHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
}

export default CardsHeader
